import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import useAxios from "hooks/useAxios";
import moment from "moment";
import ReactStrapTable from "components/reactStrapTable";

const Encounters = ({ providerIds, faxRefresh, orgId, patientId, tenantID, coveredEntityID }) => {
  const API = useAxios();
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "patientFirstName",
    order: "desc",
    filters: [],
  };

  // const { patientId, tenantID } = useParams();
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);

  const fetchEncounters = async (filters = {}, hasFilter) => {
    try {
      const { data } = await API.post(
        `/${tenantID}/Encounter/Patient/${parseInt(patientId)}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchEncounters(initialFilters);
  }, []);

  const dateFormate = (row, columnName) => {
    return (
      <>
        {row[columnName]
          ? moment(new Date(row[columnName])).format("MM/DD/YYYY")
          : "-"}
      </>
    );
  };

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };

  const columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 90,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      // cellRenderer: (row) => previewFax(row),
    },
    {
      dataField: "patientFirstName",
      text: "Patient First Name",
      sort: true,
      width: 175,
      cellRenderer: (row) => formatter(row, "patientFirstName"),
      inputType: "text",
      show: true,
    },
    {
      dataField: "patientLastName",
      text: "Patient Last Name",
      sort: true,
      width: 175,
      cellRenderer: (row) => formatter(row, "patientLastName"),
      inputType: "text",
      show: true,
    },
    {
      dataField: "patientDOB",
      text: "Patient Date of Birth",
      width: 150,
      cellRenderer: (row) => dateFormate(row, "patientDOB"),
      inputType: "date",
      sort: true,
      show: true,
    },
    {
      dataField: "medicalRecordNumber",
      text: "Medical Record Number",
      width: 160,
      // width:  '170px' ,
      cellRenderer: (row) => formatter(row, "medicalRecordNumber"),
      sort: true,
      inputType: "text",
      show: true,
    },
    {
      dataField: "encounterDate",
      text: "Encounter Date",
      width: 120,
      cellRenderer: (row) => dateFormate(row, "encounterDate"),
      inputType: "date",
      sort: true,
      show: true,
    },
    {
      dataField: "serviceLocation",
      text: "Service Location",
      width: "200px",
      cellRenderer: (row) => formatter(row, "serviceLocation"),
      sort: true,
      inputType: "text",
      show: true,
    },
    {
      dataField: "visitEncounterNumber",
      text: "Visit Encounter Number",
      width: "170px",
      cellRenderer: (row) => formatter(row, "visitEncounterNumber"),
      sort: true,
      inputType: "text",
      show: true,
    },
    {
      dataField: "providerNPI",
      text: "Rendering Provider NPI",
      width: "210px",
      cellRenderer: (row) => formatter(row, "providerNPI"),
      sort: true,
      inputType: "text",
      show: true,
    },
    {
      dataField: "providerFirstName",
      text: "Rendering Provider First Name",
      width: "210px",
      cellRenderer: (row) => formatter(row, "providerFirstName"),
      sort: false,
      inputType: "text",
      hideColFilter: true,
      show: true,
    },
    {
      dataField: "providerLastName",
      text: "Rendering Provider Last Name",
      width: "220px",
      cellRenderer: (row) => formatter(row, "providerLastName"),
      sort: false,
      inputType: "text",
      hideColFilter: true,
      show: true,
    },
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let combine = { ...filter, filters: [...colChangedFilter] };
      fetchEncounters(combine, true);
      setInitFilter(combine);
    } else {
      fetchEncounters(filter);
      setInitFilter(filter);
    }
  };

  const handleSort = (filter) => {
    fetchEncounters(filter);
    setInitFilter(filter);
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchEncounters(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    const filter = { ...initialFilters, pageSize: initFilter.pageSize, order: initFilter.order, orderBy: initFilter.orderBy };
    initialFilters.filters = [];
    setInitFilter(filter);
    fetchEncounters(filter);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let combine = { ...filter, filters: colChangedFilter };
      fetchEncounters(combine, true);
      setInitFilter(combine);
    } else {
      fetchEncounters(filter);
      setInitFilter(filter);
    }
  };

  return (
    <div className="table-card scroll-table position-relative border-0">
      <ReactStrapTable
        id="encountes"
        height={50 * data.length}
        fixedColumn
        columns={columns}
        data={data}
        handleSort={handleSort}
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        hasPagination
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={handlePageChange}
        filters={initFilter}

      ></ReactStrapTable>
    </div>
  );
};

export default Encounters;
